export default "__VITE_ASSET__DCVccxy1__"